export const enum FakeData {
  NATIONAL_CODE = '9999119999',
}
